import { AxiosError } from 'axios';
import { api } from '@shared/api';

export type UnsubscribeAction = 'unsubscribe' | 'resubscribe';

export class EmailLinkError extends Error {
  constructor(public code: 'INVALID_EMAIL_TOKEN' | 'RATE_LIMIT' | 'NETWORK' | 'UNKNOWN') {
    super(code);
    this.name = 'EmailLinkError';
  }
}

function toEmailLinkError(err: unknown): EmailLinkError {
  if (err instanceof AxiosError) {
    const status = err.response?.status;
    const code = (err.response?.data as { error?: { code?: string } } | undefined)?.error?.code;
    if (code === 'INVALID_EMAIL_TOKEN' || status === 400 || status === 422)
      return new EmailLinkError('INVALID_EMAIL_TOKEN');
    if (status === 429) return new EmailLinkError('RATE_LIMIT');
    if (!err.response || (status !== undefined && status >= 500)) return new EmailLinkError('NETWORK');
  }
  return new EmailLinkError('UNKNOWN');
}

/**
 * Отписка от напоминаний и возврат: POST /email/unsubscribe {token, action} → {status:
 * 'unsubscribed' | 'subscribed'}. Без входа — токен из письма подписан сервером; неверный токен —
 * 400 INVALID_EMAIL_TOKEN (422 — токен не прошёл схему, тоже неверная ссылка). Токен идёт только
 * в теле: в адресе запроса его увидели бы журналы и сетевые события аналитики.
 */
export async function postUnsubscribe(token: string, action: UnsubscribeAction): Promise<{ status: string }> {
  try {
    const { data } = await api.post<{ status?: unknown }>('/email/unsubscribe', { token, action });
    return { status: typeof data?.status === 'string' ? data.status : '' };
  } catch (err) {
    throw toEmailLinkError(err);
  }
}

/** Клик по ссылке из письма-напоминания: POST /email/clicked {rid} → {status: 'recorded' | 'already' |
 *  'ignored'} — бэкенд ставит clicked_at (пикселя нет). */
export async function postReminderClick(rid: string): Promise<void> {
  await api.post('/email/clicked', { rid });
}
